import { collection, getDocs } from "firebase/firestore";
import { db } from "../services/firebase";

const getAllUserDocId = async () => {
  const userDocId = [];
  const data = await getDocs(collection(db, "Score2"));
  data.docs.map((item) => userDocId.push(item.id));
  return userDocId;
};
export const getAllScoreGrade = async (grade, week) => {
  let allUserId = await getAllUserDocId();
  const allScoreAllRound = [];
  for (let i = 0; i < allUserId.length; i++) {
    const scoreObject = await getDocs(
      collection(
        db,
        "Score2",
        allUserId[i],
        `Grade${grade}`,
        `week${week}`,
        "round"
      )
    );
    allScoreAllRound.push({ scoreObject, user: allUserId[i] });
  }

  const AllScoresRound1 = allScoreAllRound.map((item) => {
    return {
      data: item.scoreObject.docs.filter((item2) => item2.id === "round1"),
      user: item.user,
    };
  });

  const AllUserScore = AllScoresRound1.map((item) =>
    item.data.map((item2) => {
      return { data: item2.data(), user: item.user };
    })
  );
  return AllUserScore;
};

export const getAllContentTS = async (grade, week) => {
  let allUserId = await getAllUserDocId();
  const allContentTSRound = [];
  for (let i = 0; i < allUserId.length; i++) {
    const contentTS = await getDocs(
      collection(
        db,
        "LessonLog",
        allUserId[i],
        `Grade${grade}`,
        `week${week}`,
        "round"
      )
    );
    allContentTSRound.push({ contentTS, user: allUserId[i] });
  }

  const AllContentTSRound1 = allContentTSRound.map((item) => {
    return {
      data: item.contentTS.docs.filter((item2) => item2.id === "round1"),
      user: item.user,
    };
  });

  const AllUserContentTS = AllContentTSRound1.map((item) =>
    item.data.map((item2) => {
      return { data: item2.data(), user: item.user };
    })
  );
  return AllUserContentTS;
};